<template>
  <div style="position: relative"  class="cabinet_sidebar">
      <div class="cabinet_logo">
        <router-link class="outline-none focus:outline-none" :to="{ name: 'home.index' }">
        <img src="/image/header-logo.svg" alt="" class="outline-none focus:outline-none active:outline-none" />
          <InlineSvg
            class="beta-badge"
            style="width: 40px"
            src="/img/beta.svg"
          ></InlineSvg>
        </router-link>
      </div>

    <ul class="cabinet_sidebar_menu">
      <li class="cursor-pointer">
        <router-link
          :class="[
            'text-base-small grey-4-color',
            {
              active: this.activeRoute.indexOf('counterparty.') === 0,
            },
          ]"
          :to="{ name: 'counterparty.index' }"
        >
          <BaseIcon
            icon="contragent-icon"
            :active="this.activeRoute.indexOf('counterparty.') === 0"
          />
          <span>{{ $t("counterparties") }}</span>
        </router-link>
      </li>
      <li class="cursor-pointer">
        <router-link
          :class="[
            'text-base-small grey-4-color',
            {
              active: this.activeRoute.indexOf('contract.') === 0,
            },
          ]"
          :to="{ name: 'contract.index' }"
        >
          <BaseIcon
            icon="contract-icon"
            :active="this.activeRoute.indexOf('contract.') === 0"
          />
          <span>{{ $t("contracts") }}</span>
        </router-link>
      </li>
      <li class="cursor-pointer">
        <router-link
          :class="[
            'text-base-small grey-4-color',
            {
              active: this.activeRoute.indexOf('mcp.') === 0,
            },
          ]"
          :to="{ name: 'mcp.access.index' }"
        >
          <BaseIcon
            icon="integration-icon"
            :active="this.activeRoute.indexOf('mcp.') === 0"
          />
          <span>{{ $t("mcp_access.menu") }}</span>
        </router-link>
      </li>
      <li class="cursor-pointer">
        <router-link
          :class="[
            'text-base-small grey-4-color',
            {
              active: this.activeRoute.indexOf('referral.') === 0,
            },
          ]"
          :to="{ name: 'referral.program.index' }"
        >
          <BaseIcon
            icon="referrals-icon"
            :active="this.activeRoute.indexOf('referral.') === 0"
          />
          <span>{{ $t("referral_program") }}</span>
        </router-link>
      </li>
      <li class="cursor-pointer">
        <router-link
          :class="[
            'text-base-small grey-4-color',
            {
              active: this.activeRoute.indexOf('profile.') === 0,
            },
          ]"
          :to="{ name: 'profile.info' }"
        >
          <BaseIcon
            icon="setting-icon"
            :active="this.activeRoute.indexOf('profile.') === 0"
          />
          <span>{{ $t("personal_settings") }}</span>
        </router-link>
      </li>
      <li class="cursor-pointer">
        <router-link
          :class="[
            'text-base-small grey-4-color',
            {
              active: this.activeRoute.indexOf('history.') === 0,
            },
          ]"
          :to="{ name: 'history.user.index' }"
        >
          <BaseIcon
            icon="history-icon"
            :active="this.activeRoute.indexOf('history.') === 0"
          />
          <span>{{ $t("sidebar.history") }}</span>
        </router-link>
      </li>
      <li class="cursor-pointer">
        <router-link
          :class="[
            'text-base-small grey-4-color',
            {
              active: this.activeRoute.indexOf('invitation.') === 0,
            },
          ]"
          :to="{ name: 'invitation.counterparties' }"
        >
          <BaseIcon
            icon="invitation-icon"
            :active="this.activeRoute.indexOf('invitation.') === 0"
          />
          <span>{{ $t("invitations") }}</span>
        </router-link>
      </li>
      <li class="cursor-pointer">
        <router-link
          :class="[
            'text-base-small grey-4-color',
            {
              active: this.activeRoute.indexOf('price.') === 0,
            },
          ]"
          :to="{ name: 'price.index' }"
        >
          <BaseIcon
            icon="price-icon"
            :active="this.activeRoute.indexOf('price.') === 0"
          />
          <span>{{ $t("sidebar.price") }}</span>
        </router-link>
      </li>
      <li class="cursor-pointer">
        <router-link
          :class="[
            'text-base-small grey-4-color',
            {
              active: this.activeRoute.indexOf('instruction.') === 0,
            },
          ]"
          :to="{ name: 'instruction.index' }"
        >
          <BaseIcon
            icon="instruction-icon"
            :active="this.activeRoute.indexOf('instruction.') === 0"
          />
          <span>{{ $t("sidebar.instruction") }}</span>
        </router-link>

      </li>
      <li class="cursor-pointer">
        <router-link
          :class="[
            'text-base-small grey-4-color',
            {
              active: this.activeRoute.indexOf('support.') === 0,
            },
          ]"
          :to="{ name: 'support.index' }"
        >
          <BaseIcon
            icon="support-icon"
            :active="this.activeRoute.indexOf('support.') === 0"
          />
          <span>{{ $t("sidebar.support") }}</span>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Sidebar",
  data() {
    return {
      activeRoute: this.$route.name
    };
  },
  watch: {
    "$route.name": {
      handler: function(name) {
        this.activeRoute = name;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.sidebar-toggle {
  position: absolute;
  right: -12px;
  top: 30px;
  width: 24px;
  height: 24px;
  background: #FFFFFF;
  border: 1px solid #E5E5E5;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.beta-badge {
  position: absolute;
  top: -8px;
  right: 73px;
  transform-origin: center;
  z-index: 0;
}

</style>
